export default "__VITE_ASSET__Bdm1Fcow__";